/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M2 10V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H8.31672C9.11834 2 9.51916 2 9.88103 2.09146C10.4791 2.24262 11.016 2.57444 11.4186 3.04174C11.6623 3.32451 11.8415 3.683 12.2 4.4V4.4C12.439 4.878 12.5585 5.11699 12.7209 5.30551C12.9894 5.61704 13.3473 5.83825 13.746 5.93902C13.9872 6 14.2544 6 14.7889 6H16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 6H16.5V6C17.8956 6 18.5933 6 19.1611 6.17224C20.4395 6.56004 21.44 7.56046 21.8278 8.83886C22 9.40666 22 10.1044 22 11.5V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H8.4C6.15979 22 5.03968 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H8.31672C9.11834 2 9.51916 2 9.88103 2.09146C10.4791 2.24262 11.016 2.57444 11.4186 3.04174C11.6623 3.32451 11.8415 3.683 12.2 4.4C12.439 4.878 12.5585 5.11699 12.7209 5.30551C12.9894 5.61704 13.3473 5.83825 13.746 5.93902C13.9872 6 14.2544 6 14.7889 6H15.6C17.8402 6 18.9603 6 19.816 6.43597C20.5686 6.81947 21.1805 7.43139 21.564 8.18404C22 9.03968 22 10.1598 22 12.4V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H8.4C6.15979 22 5.03969 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V6.8Z"
				fill="currentColor"
			/>
			<path
				d="M2 6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H8.31672C9.11834 2 9.51916 2 9.88103 2.09146C10.4791 2.24262 11.016 2.57444 11.4186 3.04174C11.6623 3.32451 11.8415 3.683 12.2 4.4V4.4C12.439 4.878 12.5585 5.11699 12.7209 5.30551C12.9894 5.61704 13.3473 5.83825 13.746 5.93902C13.9872 6 14.2544 6 14.7889 6H15.6C17.8402 6 18.9603 6 19.816 6.43597C20.5686 6.81947 21.1805 7.43139 21.564 8.18404C22 9.03968 22 10.1598 22 12.4V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H8.4C6.15979 22 5.03968 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V6.8Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M6.05 1.25C4.36984 1.25 3.52976 1.25 2.88803 1.57698C2.32354 1.8646 1.8646 2.32354 1.57698 2.88803C1.25 3.52976 1.25 4.36984 1.25 6.05V16.35C1.25 18.5902 1.25 19.7103 1.68597 20.566C2.06947 21.3186 2.68139 21.9305 3.43404 22.314C4.28969 22.75 5.40979 22.75 7.65 22.75H16.35C18.5902 22.75 19.7103 22.75 20.566 22.314C21.3186 21.9305 21.9305 21.3186 22.314 20.566C22.75 19.7103 22.75 18.5902 22.75 16.35V11.65C22.75 9.40979 22.75 8.28968 22.314 7.43404C21.9305 6.68139 21.3186 6.06947 20.566 5.68597C19.7103 5.25 18.5902 5.25 16.35 5.25H15.2524C14.718 5.25 14.4508 5.25 14.2095 5.18902C13.8108 5.08825 13.4529 4.86704 13.1845 4.55551C13.022 4.36699 12.9025 4.128 12.6635 3.65C12.305 2.933 12.1258 2.57451 11.8821 2.29174C11.4795 1.82444 10.9426 1.49262 10.3446 1.34146C9.98268 1.25 9.58187 1.25 8.78024 1.25H6.05Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 9V8.50012V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H8.31672C9.11834 2 9.51916 2 9.88103 2.09146C10.4791 2.24262 11.016 2.57444 11.4186 3.04174C11.6623 3.32451 11.8415 3.683 12.2 4.4V4.4C12.439 4.878 12.5585 5.11699 12.7209 5.30551C12.9894 5.61704 13.3473 5.83825 13.746 5.93902C13.9872 6 14.2544 6 14.7889 6H16.4999C17.8956 6 18.5934 6 19.1612 6.17227C20.4396 6.56008 21.4399 7.56044 21.8277 8.83877C22 9.40661 22 10.1044 22 11.5001V11.5001V12M2 13.0002V13.5001V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22H16.5001C17.8956 22 18.5933 22 19.161 21.8278C20.4395 21.44 21.44 20.4395 21.8278 19.161C22 18.5933 22 17.8956 22 16.5001V16.5001V16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H8.31672C9.11834 2 9.51916 2 9.88103 2.09146C10.4791 2.24262 11.016 2.57444 11.4186 3.04174C11.6623 3.32451 11.8415 3.683 12.2 4.4V4.4C12.439 4.878 12.5585 5.11699 12.7209 5.30551C12.9894 5.61704 13.3473 5.83825 13.746 5.93902C13.9872 6 14.2544 6 14.7889 6H15.6C17.8402 6 18.9603 6 19.816 6.43597C20.5686 6.81947 21.1805 7.43139 21.564 8.18404C22 9.03968 22 10.1598 22 12.4V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H8.4C6.15979 22 5.03968 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V6.8Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M6.05 1.25C4.36984 1.25 3.52976 1.25 2.88803 1.57698C2.32354 1.8646 1.8646 2.32354 1.57698 2.88803C1.25 3.52976 1.25 4.36984 1.25 6.05V16.35C1.25 18.5902 1.25 19.7103 1.68597 20.566C2.06947 21.3186 2.68139 21.9305 3.43404 22.314C4.28969 22.75 5.40979 22.75 7.65 22.75H16.35C18.5902 22.75 19.7103 22.75 20.566 22.314C21.3186 21.9305 21.9305 21.3186 22.314 20.566C22.75 19.7103 22.75 18.5902 22.75 16.35V11.65C22.75 9.40979 22.75 8.28968 22.314 7.43404C21.9305 6.68139 21.3186 6.06947 20.566 5.68597C19.7103 5.25 18.5902 5.25 16.35 5.25H15.2524C14.718 5.25 14.4508 5.25 14.2095 5.18902C13.8108 5.08825 13.4529 4.86704 13.1845 4.55551C13.022 4.36699 12.9025 4.128 12.6635 3.65C12.305 2.933 12.1258 2.57451 11.8821 2.29174C11.4795 1.82444 10.9426 1.49262 10.3446 1.34146C9.98268 1.25 9.58187 1.25 8.78024 1.25H6.05Z"
				fill="currentColor"
			/>
			<path
				d="M6.05 1.25C4.36984 1.25 3.52976 1.25 2.88803 1.57698C2.32354 1.8646 1.8646 2.32354 1.57698 2.88803C1.25 3.52976 1.25 4.36984 1.25 6.05V11C1.25 11 5 13 12 13C19 13 22.75 11 22.75 11C22.75 9.37062 22.75 8.55593 22.5162 7.90244C22.1127 6.77481 21.2252 5.8873 20.0976 5.48382C19.4441 5.25 18.6294 5.25 17 5.25H15.2524C14.718 5.25 14.4508 5.25 14.2095 5.18902C13.8108 5.08825 13.4529 4.86704 13.1845 4.55551C13.022 4.36699 12.9025 4.128 12.6635 3.65C12.305 2.933 12.1258 2.57451 11.8821 2.29174C11.4795 1.82444 10.9426 1.49262 10.3446 1.34146C9.98268 1.25 9.58187 1.25 8.78024 1.25H6.05Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
